import React from 'react'
import styled from 'styled-components'
import { URL_SELL_WITH_FLIP } from '../helpers'
import {
  buttonPurpleStyle,
  buttonBlackStyle,
  buttonWhiteStyle,
  buttonGreenStyle,
  buttonOffWhiteDarkStyle,
  bigButtonStyle,
} from '../styled'

const IS_PURPLE = 'purple'
const IS_BLACK = 'black'
const IS_WHITE = 'white'
const IS_GREEN = 'green'
const IS_OFF_WHITE_DARK = 'offWhiteDark'

const getStyleByType = ({ isColor }) => {
  switch (isColor) {
    case IS_GREEN:
      return buttonGreenStyle
    case IS_PURPLE:
      return buttonPurpleStyle
    case IS_BLACK:
      return buttonBlackStyle
    case IS_OFF_WHITE_DARK:
      return buttonOffWhiteDarkStyle
    case IS_WHITE:
      return buttonWhiteStyle
    default:
      return ''
  }
}

const ButtonWrapper = styled.a`
  text-decoration: none;
  ${getStyleByType}
  ${({ isLarge }) => isLarge && bigButtonStyle}
`

const ButtonGetStarted = ({ color, buttonLabel, isLarge }) => (
  <ButtonWrapper
    href={URL_SELL_WITH_FLIP}
    title={buttonLabel}
    isColor={color}
    isLarge={isLarge}
  >
    {buttonLabel}
  </ButtonWrapper>
)

export default ButtonGetStarted
